import { Message } from "element-ui";

/**
 * 基础折线图
 */
const linechart = data => {
    try {
        const rawArr = data[0].data;
        const xAxis_data = Object.keys(rawArr[0]).slice(1);
        if(xAxis_data.includes(null) || xAxis_data.find(item => /EMPTY/.test(item))) {
            throw 'Excel内容: 标题栏有空值，请检查补充!';
        }
        const xAxis = {
            type: 'category',
            data: xAxis_data
        };
        const series = [];
        for (let i = 0, len = rawArr.length; i < len; i++) {
            const arr = Object.values(rawArr[i]);
            if(!arr[0]) {
                throw `Excel内容: 折线名${i+1}为空!`;
            }
            if(arr.slice(1).includes(null) || arr.slice(1).find(item => /EMPTY/.test(item))) {
                throw 'Excel内容: 折线数据有空值，请检查补充(或用 0 代替)!';
            }
            series.push({
                name: arr[0],
                data: arr.slice(1),
                type: 'line',
                stack: 'Total',
                emphasis: {
                    focus: 'series'
                }
            })
        }
        return {
            xAxis: xAxis,
            yAxis: {
                type: 'value'
            },
            series: series
        }
    } catch (err) {
        const errMsg = typeof err === 'string' ? err : '文件格式错误!';
        Message({
            message: errMsg,
            type: "error",
            duration: 5000
        });
        return false
    }
}

/**
 * 基础柱状图
 */
const histogram = data => {
    try {
        const rawArr = data[0].data;
        const xAxis_data = Object.keys(rawArr[0]).slice(1);
        if(xAxis_data.includes(null) || xAxis_data.find(item => /EMPTY/.test(item))) {
            throw 'Excel内容: 标题栏有空值，请检查补充!';
        }
        const xAxis = {
            type: 'category',
            data: xAxis_data
        };
        const series = [];
        for (let i = 0, len = rawArr.length; i < len; i++) {
            const arr = Object.values(rawArr[i]);
            if(!arr[0]) {
                throw `Excel内容: 柱形名${i+1}为空!`;
            }
            if(arr.slice(1).includes(null) || arr.slice(1).find(item => /EMPTY/.test(item))) {
                throw 'Excel内容: 柱形数据有空值，请检查补充(或用 0 代替)!';
            }
            series.push({
                name: arr[0],
                data: arr.slice(1),
                type: 'bar',
                label: {
                    show: true
                }
            })
        }
        return {
            xAxis: xAxis,
            yAxis: {
                type: 'value'
            },
            series: series
        }
    } catch (err) {
        const errMsg = typeof err === 'string' ? err : '文件格式错误!';
        Message({
            message: errMsg,
            type: "error",
            duration: 5000
        });
        return false
    }
}

/**
 * 基础饼图
 */
const piechart = data => {
    try {
        const rawData = data[0].data[0];
        const type_data = Object.keys(rawData);
        const value_data = Object.values(rawData);
        if(type_data.includes(null) || type_data.find(item => /EMPTY/.test(item))) {
            throw 'Excel内容: 类型栏有空值，请检查补充!';
        }
        if(!rawData[type_data[0]].trim()) {
            throw `Excel内容: 系列名为空，请检查补充!`;
        }
        if(value_data.includes(null) || value_data.find(item => /EMPTY/.test(item))) {
            throw 'Excel内容: 饼图数据有空值，请检查补充(或用 0 代替)!';
        }
        const series_data = [];
        for(let i = 1,len = type_data.length; i < len;i++) {
            series_data.push({
                name: type_data[i],
                value: Number(rawData[type_data[i]])
            })
        }
        return {
            name: rawData[type_data[0]],
            type: "pie",
            data: series_data,
            emphasis: {},
            itemStyle: {}
        }
        
    } catch (err) {
        const errMsg = typeof err === 'string' ? err : '文件格式错误!';
        Message({
            message: errMsg,
            type: "error",
            duration: 5000
        });
        return false
    }
}

export {
    linechart,
    histogram,
    piechart
}